import React from 'react'
import { Navigate, Route, Routes} from 'react-router-dom'

import { SRDashboardPage } from '../components'

export const SRRouter = () => {
  return (
    <Routes>
      <Route path="/sr" element={<SRDashboardPage />} />
      <Route path="*" element={<Navigate to="/sr" />} />
    </Routes>
  )
}
